import { render } from "./AddModalTypeChargement.vue?vue&type=template&id=3728cc6e&ts=true"
import script from "./AddModalTypeChargement.vue?vue&type=script&lang=ts"
export * from "./AddModalTypeChargement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__